import React from 'react'
import parse from 'html-react-parser'

export default function ProjectsFilterCategories ({categories, value, onChange}) {
  return (
    <>
      <div className={'mt-projects-archive__filter-container--terms'}>
        {categories.map(category => (
          <ProjectsFilterTypesItem key={category.termId} category={category} selected={category.termId === value} onClick={onChange}/>
        ))}
      </div>
      <select className={'mt-projects-archive__filter-container--terms select'} onChange={(e) => onChange(parseInt(e.target.value))}>
        {categories.map(category => (
          <ProjectsFilterTypesSelectItem key={category.termId} category={category} selected={category.termId === value}/>
        ))}
      </select>
    </>
  )
}

function ProjectsFilterTypesItem ({category, selected, onClick}){
  return (
    <button className={selected ? 'active' : ''} onClick={() => onClick(category.termId)} >
      {parse(category.icon)}{category.name}
    </button>
  )
}

function ProjectsFilterTypesSelectItem ({category, selected}){
  return (
    <option value={category.termId}>
      {category.name}
    </option>
  )
}
